(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["configurator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const dataEl = document.getElementById('configurator-data');
    if (!dataEl) return;
    let variantInfo;
    try {
      variantInfo = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('Konfigurator: Varianten-Daten konnten nicht gelesen werden.', e);
      return;
    }
    const MAX_PER_CELL = 6;
    const MAX_QTY = 12;

    const previewEmpty = document.getElementById('configurator-empty');
    const tableEl = document.getElementById('configurator-table');
    const summaryEl = document.getElementById('configurator-summary');
    const countEl = document.getElementById('configurator-count');
    const priceEl = document.getElementById('configurator-price');
    const addBtn = document.getElementById('configurator-add');
    const noteEl = document.getElementById('configurator-note');

    const categoryEls = document.querySelectorAll('.configurator__category');
    const cells = document.querySelectorAll('.configurator__cell');

    // category -> Map(variantId -> qty)
    const state = {};
    categoryEls.forEach((cat) => {
      state[cat.dataset.category] = new Map();
    });

    function currentSelection() {
      const selection = [];
      Object.keys(state).forEach((category) => {
        state[category].forEach((qty, variantId) => {
          const info = variantInfo[variantId];
          if (!info) return;
          selection.push({ category, variantId, qty, info });
        });
      });
      return selection;
    }

    function renderChips(cat) {
      const category = cat.dataset.category;
      const map = state[category];
      const chipsWrap = cat.querySelector('[data-selected-for="' + category + '"]');
      chipsWrap.innerHTML = '';

      map.forEach((qty, variantId) => {
        const btn = cat.querySelector('.configurator__variant-btn[data-variant-id="' + variantId + '"]');
        const label = btn ? btn.dataset.label : '';

        const row = document.createElement('div');
        row.className = 'configurator__selected-item';

        const labelEl = document.createElement('span');
        labelEl.className = 'configurator__selected-label';
        labelEl.textContent = label;
        row.appendChild(labelEl);

        const stepper = document.createElement('span');
        stepper.className = 'configurator__stepper';

        const minus = document.createElement('button');
        minus.type = 'button';
        minus.className = 'configurator__stepper-btn';
        minus.textContent = '–';
        minus.addEventListener('click', () => {
          const newQty = qty - 1;
          if (newQty <= 0) {
            map.delete(variantId);
            if (btn) btn.classList.remove('is-selected');
          } else {
            map.set(variantId, newQty);
          }
          renderChips(cat);
          render();
        });

        const value = document.createElement('span');
        value.className = 'configurator__stepper-value';
        value.textContent = qty;

        const plus = document.createElement('button');
        plus.type = 'button';
        plus.className = 'configurator__stepper-btn';
        plus.textContent = '+';
        plus.addEventListener('click', () => {
          const newQty = Math.min(MAX_QTY, qty + 1);
          map.set(variantId, newQty);
          renderChips(cat);
          render();
        });

        stepper.appendChild(minus);
        stepper.appendChild(value);
        stepper.appendChild(plus);
        row.appendChild(stepper);

        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'configurator__remove';
        remove.setAttribute('aria-label', 'Entfernen');
        remove.textContent = '×';
        remove.addEventListener('click', () => {
          map.delete(variantId);
          if (btn) btn.classList.remove('is-selected');
          renderChips(cat);
          render();
        });
        row.appendChild(remove);

        chipsWrap.appendChild(row);
      });
    }

    function render() {
      const selection = currentSelection();

      cells.forEach((cell) => {
        cell.innerHTML = '';
      });

      if (selection.length === 0) {
        previewEmpty.hidden = false;
        summaryEl.hidden = true;
        addBtn.disabled = true;
        return;
      }

      previewEmpty.hidden = true;
      summaryEl.hidden = false;
      addBtn.disabled = false;
      noteEl.hidden = true;

      let totalItems = 0;
      let totalPrice = 0;

      // group by category so the per-cell cap counts all variants together
      const byCategory = {};
      selection.forEach((entry) => {
        totalItems += entry.qty;
        totalPrice += entry.qty * parseFloat(entry.info.price);
        if (!byCategory[entry.category]) byCategory[entry.category] = [];
        byCategory[entry.category].push(entry);
      });

      Object.keys(byCategory).forEach((category) => {
        const cell = tableEl.querySelector('[data-cell="' + category + '"]');
        if (!cell) return;

        // Jede ausgewählte Variante wird nur EINMAL abgebildet, unabhängig von
        // ihrer Menge - die Menge betrifft nur den Warenkorb, nicht das Bild.
        const entries = byCategory[category];
        let shown = 0;
        entries.forEach(({ info }) => {
          if (shown >= MAX_PER_CELL) return;
          const tile = document.createElement('div');
          tile.className = 'configurator__tile';
          const src = info.image;
          if (src) {
            const img = document.createElement('img');
            img.src = src;
            img.alt = info.label;
            img.loading = 'lazy';
            tile.appendChild(img);
          } else {
            const placeholder = document.createElement('span');
            placeholder.className = 'configurator__tile-placeholder';
            placeholder.textContent = info.label;
            tile.appendChild(placeholder);
          }
          cell.appendChild(tile);
          shown++;
        });

        if (entries.length > MAX_PER_CELL) {
          const more = document.createElement('div');
          more.className = 'configurator__tile configurator__tile--more';
          more.textContent = '+' + (entries.length - MAX_PER_CELL);
          cell.appendChild(more);
        }
      });

      countEl.textContent = totalItems + (totalItems === 1 ? ' Teil' : ' Teile');
      priceEl.textContent = totalPrice.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    }

    categoryEls.forEach((cat) => {
      const category = cat.dataset.category;
      const toggle = cat.querySelector('.configurator__toggle');
      const panel = cat.querySelector('.configurator__panel');

      toggle.addEventListener('change', () => {
        panel.hidden = !toggle.checked;
        if (!toggle.checked) {
          state[category].clear();
          cat.querySelectorAll('.configurator__variant-btn.is-selected').forEach((b) => b.classList.remove('is-selected'));
          renderChips(cat);
        }
        render();
      });

      cat.querySelectorAll('.configurator__variant-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const variantId = btn.dataset.variantId;
          const map = state[category];
          if (map.has(variantId)) {
            map.delete(variantId);
            btn.classList.remove('is-selected');
          } else {
            map.set(variantId, 1);
            btn.classList.add('is-selected');
          }
          renderChips(cat);
          render();
        });
      });
    });

    addBtn.addEventListener('click', () => {
      const selection = currentSelection();
      if (selection.length === 0) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Wird hinzugefügt …';

      const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: selection.map((s) => ({ id: parseInt(s.variantId, 10), quantity: s.qty })),
        }),
      })
        .then((res) => {
          if (!res.ok) throw new Error('Cart add failed');
          return res.json();
        })
        .then(() => {
          addBtn.disabled = false;
          addBtn.textContent = 'In den Warenkorb';
          noteEl.hidden = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(() => {
          addBtn.disabled = false;
          addBtn.textContent = 'In den Warenkorb';
        });
    });

    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
